
/*
	jv-select2-modal-dropdown
	====================

	Select2 dropdown is open inside a modal doesn't collapse when the modal is closed.
	This directive makes sure when the modal closes we force the select2 dropdown to close
	This is an open bug with select2. https://github.com/ivaynberg/wicket-select2/issues/13

	Usage
	-----
	<div jv-select2-modal-dropdown="condition for the modal to show up"></div>
 */

angular.module('jv.Common.Directives.jvSelect2ModalDropdown', [])

.directive('jvSelect2ModalDropdown', function(){
	return {
		link: function(scope, Elem, Attrs) {
			//In this case i have to use parent because this modal is on a child controller
			 scope.$watch(Attrs.jvSelect2ModalDropdown,function(newValue,oldValue){
			 	if(newValue==false){
			 		//if the modal is closed force select2dropdown to close.
			 		$('.select2-drop-active').select2('close'); 
			 	}
			 },true);
		}
	};
});